import React from 'react';
import VideoThumbnail from './VIdeoThumbnail';

const Videos = ({videoList}) => (
  <div className="video-list">
    {videoList.map(video => <VideoThumbnail key={video.link} {...video} />)}
  </div>
);

export default Videos;